export default __webpack_public_path__ + "static/media/arrow.099102e4.svg";